import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Result from '@/views/Result.vue';
import Home from '../views/Home.vue';
import HistoryPage from '../views/HistoryPage.vue';
import WinLosePage from '../views/WinLosePage.vue';
import RankingPage from '../views/RankingPage.vue';
import ToggleHistory from '../views/ModalFramePage.vue';
import FreePlay from '../views/FreePlay.vue';

Vue.use(VueRouter);
const routes: Array<RouteConfig> = [
  { path: '/', name: 'Game', component: FreePlay },
  { path: '/history', name: 'HistoryPage', component: HistoryPage },
  { path: '/winlose', name: 'WinLosePage', component: WinLosePage },
  { path: '/ranking', name: 'RankingPage', component: RankingPage },
  { path: '/togglehistory', name: 'ToggleHistory', component: ToggleHistory },
  { path: '/result', name: 'Result', component: Result },

  // ต้องอยู่ **ท้ายสุด** เพราะ /game/:demo/:provider เป็น dynamic
  { path: '/game/:demo/:prefix', name: 'Game', component: FreePlay },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
